import { ScrollView } from "@dhx/ts-common/ScrollView";
import { IProDataView, IDataViewConfig } from "./types";
import { DataView } from "./DataView";
import { VNode, el } from "@dhx/ts-common/dom";

export class ProDataView extends DataView implements IProDataView {
	public scrollView: ScrollView;

	constructor(node: HTMLElement | string, config: IDataViewConfig = {}) {
		super(node, config);
		this.scrollView = new ScrollView(() => this.getRootView());
		this.paint();
	}

	destructor() {
		super.destructor();
		this.scrollView = null;
	}

	showItem(id: string): void {
		const rootView = this.getRootView();
		if (!rootView || !rootView.node || !rootView.node.el || typeof id === "undefined") {
			return;
		}

		const dataViewEl: Element = this.getRootNode().getElementsByClassName("scroll-view")[0];
		if (!dataViewEl) {
			return;
		}

		const virtual = this.config.virtual;
		const index = this.data.getIndex(id);
		const currentRow = Math.floor(index / this.config.itemsInRow);
		const currentPage = Math.floor(currentRow / dataViewEl.children.length) || 0;
		const itemRow = dataViewEl.children[
			currentRow - dataViewEl.children.length * currentPage
		] as HTMLElement;

		if (!virtual && !itemRow) return;
		const item = itemRow.children[index % this.config.itemsInRow] as HTMLElement;
		const gap = parseInt(this.config.gap.toString().replace("px", ""), null);

		if (item.offsetTop >= dataViewEl.clientHeight + dataViewEl.scrollTop - item.clientHeight) {
			dataViewEl.scrollTop = item.offsetTop - dataViewEl.clientHeight + item.clientHeight + gap;
		} else if (item.offsetTop < dataViewEl.scrollTop - gap) {
			dataViewEl.scrollTop = item.offsetTop - gap;
		}
	}

	protected _renderList(): VNode {
		const data = this.data.getRawData(0, -1);

		const { itemsInRow, css, gap } = this.config;
		let currentCounter = 0;
		const rows = data.reduce((items, obj, index) => {
			if (currentCounter === 0) {
				items.push([]);
			}
			items[items.length - 1].push(this._renderItem(obj, index));
			currentCounter = (currentCounter + 1) % itemsInRow;
			return items;
		}, []);

		const kids = rows.map((row, index) =>
			el(
				".dhx_dataview-row",
				{
					style: { margin: gap },
					"aria-label": `Row ${index + 1}`,
				},
				row
			)
		);

		const scrollViewEnable = this.scrollView && this.scrollView.config.enable;
		const currentClass =
			(css ? css : "") +
			" dhx_widget dhx_dataview" +
			(this.config.multiselection && this.selection.getItem() ? " dhx_no-select--pointer" : "") +
			(scrollViewEnable ? " dhx_dataview--scroll-view" : "");

		return el(
			"",
			{
				...this._handlers,
				"data-dhx-widget-id": this._uid,
				class: currentClass,

				style: {
					height: this.config.height,
				},
				...this.getDataViewAriaAttrs(this.config, this.data.getLength(), rows.length, itemsInRow),
			},
			scrollViewEnable ? [this.scrollView.render(kids)] : kids
		);
	}
}
